import { CustomCol } from "./Col"
import { CustomRow } from "./Row"

export const Row = {
  Container: CustomRow,
  Col: CustomCol,
}
